import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { images, site } from "../data/site";
import { MoroccanDivider } from "../components/MoroccanDivider";
import { useT } from "../data/i18n";

export const About = () => {
  const { t } = useT();
  return (
    <>
      <Seo title="Sobre nosotros | Cocina árabe familiar en La Cerdanya — Yasmina" description="Conoce Yasmina: recetas heredadas, especias del mundo árabe y cocina halal a fuego lento en la Plaça del Reg de Puigcerdà." path="/sobre-nosotros" />
      <section className="menu-hero">
        <div className="container">
          <Reveal><div className="label">{t("about_kicker")}</div></Reveal>
          <Reveal delay={1}>
            <h1>{t("about_title")}</h1>
          </Reveal>
          <Reveal delay={2}>
            <p>{t("about_lead")}</p>
          </Reveal>
        </div>
      </section>

      <section className="philosophy">
        <div className="container">
          <div className="cols">
            <Reveal><p style={{ color: "var(--text)" }}>{t("about_p1")}</p></Reveal>
            <Reveal delay={1}><p style={{ color: "var(--text)" }}>{t("about_p2")}</p></Reveal>
          </div>
          <div className="divider" />
          <Reveal>
            <div
              className="band"
              style={{ backgroundImage: `url(${images.interior})` }}
              role="img"
              aria-label="Interior del restaurante Yasmina Plaça del Reg Puigcerdà"
            />
          </Reveal>
        </div>
      </section>

      <MoroccanDivider />

      <section style={{ textAlign: "center", padding: "60px 0 120px" }}>
        <Reveal>
          <h2 style={{ maxWidth: 720, margin: "0 auto 26px" }}>{t("about_cta_title")}</h2>
        </Reveal>
        <Reveal delay={1}>
          <p style={{ maxWidth: 500, margin: "0 auto 26px" }}>{site.address}</p>
        </Reveal>
        <Reveal delay={2}>
          <a href={site.mapLink} target="_blank" rel="noreferrer" className="btn primary" data-testid="about-cta-wa">
            {t("btn_map")}
          </a>
        </Reveal>
      </section>
    </>
  );
};
